<template>
  <div>
    <div v-if="show">
      <div v-if="isNoData">
        お知らせはありません
      </div>
      <div v-else>
        <div v-for="(detail, i) in data" :key="i" class="inline-container">
          <router-link v-if="i<=2" :to="{name: 'News', params:{id: detail.id}}">
            {{detail['date_text']}} {{detail.title}}
          </router-link>
        </div>
      </div>
    </div>
    <div v-else class="inline-container">
      読み込み中...
    </div>
  </div>
</template>

<script>

export default {
  props: ['isHeadline', 'isList', 'isDetail', 'preload'],
  components: {},
  data () {
    return {
      store: 'news',
      lock: false,
      data: {},
      show: false,
      id: null,
    };
  },
  created: function () {
    this.initialize();
  },
  watch: {
    '$route' () {
      this.initialize();
    },
  },
  computed: {
    isNoData: function () {

      if (Object.keys(this.data).length === 0) {
        return true;
      } else {
        return false;
      }

    },
  },
  methods: {
    initialize: function () {

      let params = {
        s: this.$store.getters['auth/session']
      };
      // console.log(params);

      let dispatch = this.store + '/latest';

      this.$store.dispatch(dispatch, params).then(() => {

        // ロック解除
        this.lock = false;

        let status = this.$store.getters[this.store + '/status'];

        if (status === 200) {

          this.data = this.$store.getters[this.store + '/latest'];

        }

        this.show = true;

      }).catch((err) => {
        console.warn(err);

        this.show = true;
      });
    }

  }
};

</script>

<style lang="scss" scoped>

  .inline-container {
    line-height: 30px;
  }

  a {
    border-bottom: 1px solid #eee;
    padding: 0 4px;
  }

</style>
